import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";
import api, { formatApiErrorDetail } from "../lib/api";
import { Logo } from "../components/Logo";
import { Button, Field, Input, PasswordInput } from "../components/ui-kit";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e2) { toast.error(formatApiErrorDetail(e2.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  return (
    <Shell title="Recupero password" subtitle="Inserisci la tua email: riceverai le istruzioni per reimpostare la password.">
      {sent ? (
        <p className="text-sm text-slate-600 font-body" data-testid="forgot-sent">
          Se l'email è associata a un account, riceverai un link per il reset. Controlla la posta.
        </p>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <Field label="Email"><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" /></Field>
          <Button type="submit" variant="primary" loading={loading} className="w-full" data-testid="forgot-submit">Invia istruzioni</Button>
        </form>
      )}
      <BackLink />
    </Shell>
  );
}

export function ResetPassword() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const [pwd, setPwd] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      await api.post("/auth/reset-password", { token: sp.get("token"), new_password: pwd });
      toast.success("Password aggiornata. Ora puoi accedere.");
      nav("/login");
    } catch (e2) { toast.error(formatApiErrorDetail(e2.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  return (
    <Shell title="Nuova password" subtitle="Imposta una nuova password (minimo 12 caratteri).">
      <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
        <Field label="Nuova password"><PasswordInput required minLength={12} value={pwd} onChange={(e) => setPwd(e.target.value)} data-testid="reset-password" /></Field>
        <Button type="submit" variant="primary" loading={loading} className="w-full" data-testid="reset-submit">Aggiorna password</Button>
      </form>
      <BackLink />
    </Shell>
  );
}

function Shell({ title, subtitle, children }) {
  return (
    <div className="min-h-screen grid place-items-center bg-haccp-bg p-6">
      <div className="w-full max-w-md animate-fade-up">
        <div className="flex justify-center mb-6"><Logo size="lg" /></div>
        <div className="bg-white rounded-2xl shadow-card p-7">
          <h2 className="text-center font-heading text-2xl font-bold mb-1">{title}</h2>
          <p className="text-center text-slate-500 text-sm mb-6 font-body">{subtitle}</p>
          {children}
        </div>
      </div>
    </div>
  );
}

function BackLink() {
  return (
    <Link to="/login" className="mt-5 flex items-center justify-center gap-1.5 text-sm text-slate-500 hover:text-navy">
      <ArrowLeft className="w-4 h-4" /> Torna all'accesso
    </Link>
  );
}
